import { dateToDateOnlyApiFormat, parseDateOnly } from '@/helpers/dateHelper';
import { useGetMyLeaveRequestPreviewQuery } from '../gql/graphql.generated';

export const useLeaveRequestPreview = (leaveTypeId: string, start: Date, end: Date) => {
  const [{ data, fetching }] = useGetMyLeaveRequestPreviewQuery({
    variables: {
      leaveTypeId,
      dateRange: { start: dateToDateOnlyApiFormat(start), end: dateToDateOnlyApiFormat(end) }
    },
    pause: !leaveTypeId || start > end,
    requestPolicy: 'network-only'
  });

  const preview = data?.myLeaveRequestPreview;

  const overlappingDates = (preview?.overlappingDates ?? []).map(parseDateOnly);

  return {
    hasPreview: !!preview,
    checks: preview?.checks ?? [],
    daysToTake: preview?.daysToTake ?? 0,
    fetching,
    exceeded: preview?.checks.some(c => c.exceeds) ?? false,
    overlappingDates: overlappingDates,
    hasOverlap: overlappingDates.length > 0
  };
};
